import { DEFAULT_RANGE } from "../components/rangeSlider/lib/constant";

export const DEFAULT_ENERGY_PANEL = {
    modelNumber: "",
    capacity: "",

    estimatedYearlyCost: "",
    estimatedCostLowRange: "",
    estimatedCostHighRange: "",
    estimatedCostLabel: "",
    estimatedCostLabelRange: "",
    estimatedEnergyUseValue: "",
    estimatedEnergyUseUom: "",
    estimatedEnergyUseTitle: "",

    legalTerms: "",
    governmentWebsite: "Visit ftc.gov/energy.",
    additionalProductDetails: "",
    hasEnergyStarLogo: false,
    ranges: [{ ...DEFAULT_RANGE }],
};
